import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Button from '@material-ui/core/Button';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const TableCellTitleStrong = withStyles((theme) => ({
  head: {
    fontSize: 14,
    fontWeight: 'bold',
    borderBottom: 'none !important'
  }
}))(TableCell);

const useStyles = makeStyles({
  trashIcon: {
    cursor: 'pointer'
  },
  invisibleButton: {
    opacity: 0
  }
});

const TableRowCollapsible = ({
  rows,
  order,
  onClickDelete,
  onClickAmend,
  saved
}) => {
  const [open, setOpen] = useState(false);

  const classes = useStyles();

  return (
    <>
      <TableRow key={Math.random()}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {order.name}
        </TableCell>
        <TableCell component="th" scope="row">
          21/12/2020
        </TableCell>
        <TableCell component="th" scope="row">
          $3000 representing at a unit price of XXX
        </TableCell>

        <TableCell align="center">
          {saved ? (
            <Button size="small" variant="outlined" onClick={() => {}}>
              Confirm
            </Button>
          ) : (
            <Button
              className={classes.invisibleButton}
              size="small"
              variant="outlined"
              onClick={() => {}}>
              novisible
            </Button>
          )}
        </TableCell>

        <TableCell align="center">
          <Button size="small" variant="outlined" onClick={onClickAmend}>
            Amend
          </Button>
        </TableCell>
        <TableCell align="center">
          <DeleteOutlineIcon
            className={classes.trashIcon}
            color="error"
            fontSize="small"
            onClick={() => onClickDelete(order)}
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse unmountOnExit in={open} timeout="auto">
            <Box>
              <Typography gutterBottom variant="h5" component="div">
                History
              </Typography>
              <Table size="small" aria-label="history">
                <TableHead>
                  <TableRow>
                    <TableCellTitleStrong>Date</TableCellTitleStrong>
                    <TableCellTitleStrong>Order details</TableCellTitleStrong>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((historyRow) => (
                    <TableRow key={historyRow.date}>
                      <TableCell component="th" scope="row">
                        {historyRow.date}
                      </TableCell>
                      <TableCell>{historyRow.details}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

TableRowCollapsible.propTypes = {
  onClickAmend: PropTypes.func.isRequired,
  onClickDelete: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  rows: PropTypes.array.isRequired,
  saved: PropTypes.bool.isRequired
};

export default TableRowCollapsible;
